module.exports = [{"type":"title","text":"2025-01-22"},{"type":"normal","text":"","style":{"font-weight":"bold"},"children":[{"type":"html","text":"Perpetual USDT-Margined: Added the Status field to all place order related interfaces"}]}]


//////////////////
// WEBPACK FOOTER
// ./src/config/en-US/changelog/2025-01-22.json
// module id = kUTM
// module chunks = 3